// ============================================================================
// LES JOURS D'UNE LOCATION — le transit de 2 jours OUVRÉS de part et d'autre des dates louées.
//
// UTILITÉ : la page Locations dessine ce transit, la correction d'une location annonce le jour où l'appareil revient au
// parc. Une seule règle pour les deux : écrite deux fois, l'une compterait un jour de plus que l'autre.
// ============================================================================

/** Jours ouvrés de transit avant et après une location. */
export const TRANSIT_BUSINESS_DAYS = 2;

/** Décale une date de n jours OUVRÉS (le week-end ne compte pas). */
export function addBusinessDays(d: Date, n: number): Date {
  const out = new Date(d);
  const step = n < 0 ? -1 : 1;
  let left = Math.abs(n);
  while (left > 0) {
    out.setDate(out.getDate() + step);
    const dow = out.getDay();
    if (dow !== 0 && dow !== 6) left--;
  }
  return out;
}
